<div class="pickup-next{{mode ? ' -mode-'+mode : ' -mode-filter' }}">
    <div class="pickup-next__inner">
        <shared-circle-btn [disabled]="disabled" [feel]="mode === 'filter' ? 'light-accent' : 'brand-accent'"
            [hoverShadow]="mode === 'filter' ? false : true" [icon]="icon" (onClick)="nextClicked($event)">
        </shared-circle-btn>
    </div>
</div>